// https://vuex.vuejs.org/en/actions.html
import { db, storage, functions } from '@/firebase'

export default {
  traducir({ }, datos) {
    var traducir = functions.httpsCallable('httpNegociosTraducir');
    return traducir(datos).then((r) => r.data)
  }
}
